var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.879 0.468878L24.2345 4.47545L31 8.90376H17.879V0.468878Z",
    fill: "#012946"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3477 0.756968L24.1298 4.4494L30.4953 8.57906H18.3477V0.756968Z",
    fill: "#002D62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 8.43502L24.6446 4.42845L17.8791 0.000138283H31V8.43502Z",
    fill: "#0679CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2201 21.2747L18.9107 17.9653L15.6013 21.2747H22.2201Z",
    fill: "#002D62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9103 12.2919H13.7098V13.7102H18.9103V12.2919Z",
    fill: "#0679CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7102 12.5287H12.2919V13.4743H13.7102V12.5287Z",
    fill: "#002D62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6634 15.6014C22.6827 15.7563 22.6927 15.9141 22.6927 16.0742C22.6927 16.2343 22.6827 16.3921 22.6634 16.547H24.5837V15.6014H22.6634ZM22.6634 15.6014C22.4308 13.7357 20.8392 12.292 18.9105 12.292C16.8217 12.292 15.1284 13.9854 15.1284 16.0742C15.1284 18.163 16.8217 19.8563 18.9105 19.8563C20.8392 19.8563 22.4308 18.4126 22.6634 16.547H19.7296C19.5661 16.8296 19.2605 17.0197 18.9105 17.0197C18.3883 17.0197 17.965 16.5964 17.965 16.0742C17.965 15.552 18.3883 15.1287 18.9105 15.1287C19.2605 15.1287 19.5661 15.3188 19.7296 15.6014H22.6634Z",
    fill: "#0679CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2201 21.2746H15.6013V21.7473H22.2201V21.2746Z",
    fill: "#012946"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5837 15.6017H22.6927V16.5472H24.5837V15.6017Z",
    fill: "#002D62"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5837 15.6011H22.6927V16.5467H24.5837V15.6011Z",
    fill: "#002D62"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9105 17.0197C18.3883 17.0197 17.965 16.5964 17.965 16.0742C17.965 15.552 18.3883 15.1286 18.9105 15.1286C19.2606 15.1286 19.5663 15.3189 19.7297 15.6017H22.6926V16.5472H19.7294C19.5659 16.8297 19.2604 17.0197 18.9105 17.0197Z",
    fill: "#002D62"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36353 13.4528L5.6729 10.1434L8.98227 13.4528H2.36353Z",
    fill: "#002D62"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67346 4.47H10.8739V5.8883H5.67346V4.47Z",
    fill: "#0679CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8735 4.7068H17.879V5.65233H10.8735V4.7068Z",
    fill: "#002D62"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2374 5.58744L13.2374 12.5929L12.2919 12.5929L12.2919 5.58744L13.2374 5.58744Z",
    fill: "#002D62"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5293 8.38104L25.5293 16.5437L24.5838 16.5437L24.5837 8.38104L25.5293 8.38104Z",
    fill: "#002D62"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92033 7.77933C1.90102 7.9342 1.89107 8.09199 1.89107 8.2521C1.89107 8.4122 1.90102 8.56999 1.92033 8.72486H0V7.77933H1.92033ZM1.92033 7.77933C2.15298 5.91364 3.7445 4.46995 5.67321 4.46995C7.76203 4.46995 9.45536 6.16328 9.45536 8.2521C9.45536 10.3409 7.76203 12.0342 5.67321 12.0342C3.7445 12.0342 2.15298 10.5906 1.92033 8.72486H4.85417C5.01766 9.00748 5.32323 9.19763 5.67321 9.19763C6.19542 9.19763 6.61875 8.7743 6.61875 8.2521C6.61875 7.72989 6.19542 7.30656 5.67321 7.30656C5.32323 7.30656 5.01766 7.49671 4.85417 7.77933H1.92033Z",
    fill: "#0679CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36353 13.4526H8.98227V13.9254H2.36353V13.4526Z",
    fill: "#012946"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.77976H1.89107V8.7253H0V7.77976Z",
    fill: "#002D62"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.77922H1.89107V8.72475H0V7.77922Z",
    fill: "#002D62"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67321 9.19776C6.19541 9.19776 6.61874 8.77443 6.61874 8.25223C6.61874 7.73003 6.19541 7.30671 5.67321 7.30671C5.32311 7.30671 5.01746 7.49698 4.85401 7.77976H1.89111V8.72529H4.85435C5.01788 9.00775 5.32336 9.19776 5.67321 9.19776Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClro);
export default __webpack_public_path__ + "static/media/CLRO.24e928b76e9608354cf0565b2bd37aa6.svg";
export { ForwardRef as ReactComponent };